import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["step"];

  next(event) {
    event.preventDefault();

    const currentStep = this.stepTargets.findIndex(step => !step.classList.contains('hidden'));

    if (currentStep === -1) {
      console.warn("No visible step found.");
      return;
    }

    if (currentStep < this.stepTargets.length - 1) {
      this.stepTargets[currentStep].classList.add('hidden');
      this.stepTargets[currentStep + 1].classList.remove('hidden');
    }
  }
}
